import * as activeLoads from '@store/features-store/loads-active/active-loads.reducer';
import * as alerts from './features-store/alert/alert.reducer';
import * as apis from './features-store/apis/apis.reducer';
import * as auth from '@store/root-store/auth/auth.reducer';
import * as companies from './features-store/company/company.reducer';
import * as completedLoads from './features-store/loads-completed/completed-loads.reducer';
import * as devicesDetails from './features-store/devices/devices-details.reducer';
import * as devicesSummary from './features-store/devices/devices-summary.reducer';
import * as driverLog from './features-store/driver-log/driver-log.reducer';
import * as drivers from './features-store/driver/driver.reducer';
import * as dvirForms from '@store/features-store/dvir-forms/dvir-forms.reducer';
import * as dvir from '@store/features-store/dvir/dvir.reducer';
import * as eldEvents from './features-store/eld-event/eld-event.reducer';
import * as elds from './features-store/eld/eld.reducer';
import * as fleetManagers from './features-store/fleet-manager/fleet-manager.reducer';
import * as geofences from './features-store/geofence/geofence.reducer';
import * as globalFilter from '@store/root-store/global-filter/global-filter.reducer';
import * as gpsDevices from './features-store/gps-device/gps-device.reducer';
import * as gpsDevicesDetails from './features-store/devices/gps-devices-details.reducer';
import * as groups from '@store/features-store/group/group.reducer';
import * as loader from '@store/root-store/loader/loader.reducer';
import * as maintenance from '@store/features-store/maintenance/maintenance.reducer';
import * as notifications from './features-store/notification/notification.reducer';
import * as quickSearch from './features-store/quick-search/quick-search.reducer';
import * as schedules from '@store/features-store/schedule/schedule.reducer';
import * as speeding from './features-store/speeding/speeding.reducer';
import * as staticData from '@store/root-store/static-data/static-data.reducer';
import * as superAdmins from './features-store/super-admin/super-admin.reducer';
import * as trailerFleet from './features-store/trailer-fleet/trailer-fleet.reducer';
import * as trailers from './features-store/trailer/trailer.reducer';
import * as upcomingLoads from './features-store/loads-upcoming/upcoming-loads.reducer';
import * as vehicleFleet from './features-store/vehicle-fleet/vehicle-fleet.reducer';
import * as vehicles from './features-store/vehicle/vehicle.reducer';
import * as accessories from '@store/features-store/accessories/accessories.reducer';
import * as reports from '@store/features-store/reports/reports.reducer';
import * as support from '@store/features-store/support/support.reducer';

export interface RootState {
  auth: auth.UserState;
  globalFilters: globalFilter.GlobalFilterState;
  loader: loader.LoaderState;
  staticData: staticData.StaticDataState;
}

export interface AppState extends RootState {
  activeLoads: activeLoads.ActiveLoadsState;
  alerts: alerts.AlertState;
  apis: apis.ApisState;
  companies: companies.CompanyState;
  completedLoads: completedLoads.CompletedLoadsState;
  devicesDetails: devicesDetails.DevicesDetailsState;
  devicesSummary: devicesSummary.DevicesSummaryState;
  driverLogs: driverLog.DriverLogState;
  drivers: drivers.DriverState;
  dvir: dvir.DvirState;
  dvirForms: dvirForms.DvirFormsState;
  eldEvents: eldEvents.EldEventState;
  elds: elds.EldState;
  fleetManagers: fleetManagers.FleetManagerState;
  geofences: geofences.GeofenceState;
  gpsDevices: gpsDevices.GpsDeviceState;
  gpsDevicesDetails: gpsDevicesDetails.GpsDevicesDetailsState;
  groups: groups.GroupState;
  maintenance: maintenance.MaintenanceState;
  notifications: notifications.NotificationState;
  quickSearch: quickSearch.QuickSearchState;
  schedules: schedules.ScheduleState;
  speeding: speeding.SpeedingState;
  superAdmins: superAdmins.SuperAdminState;
  trailerFleet: trailerFleet.TrailerFleetState;
  trailers: trailers.TrailerState;
  upcomingLoads: upcomingLoads.UpcomingLoadsState;
  vehicleFleet: vehicleFleet.VehicleFleetState;
  vehicles: vehicles.VehicleState;
  accessories: accessories.AccessoriesState;
  reports: reports.ReportsState;
  support: support.SupportState;
}

export const reducers = {
  auth: auth.reducer,
  loader: loader.reducer,
  staticData: staticData.reducer,
  globalFilters: globalFilter.reducer,
};
